import React from "react";
import { SearchTeamList } from "../../../../model/branch/BranchTeamModel";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Center from "../../../../widget/common/ui/Center";
import Loader from "../../../../widget/common/ui/Loader";
import { Col, Row } from "react-bootstrap";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { textCase } from "../../../../service/ui/UI";
import NoData from "../../../../widget/common/ui/NoData";
import AppTheme from "../../../../service/app_config/AppTheme";

const BranchTeamList = (props: {
  teamList: Array<SearchTeamList> | null;
  type?: number | undefined;
  onClickTeam: (detail: SearchTeamList) => void;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  return (
    <>
      {props.teamList == null ? (
        <Center className="h-100">{Loader.normal()}</Center>
      ) : props.teamList.length === 0 ? (
        <Center>
          <NoData />
        </Center>
      ) : (
        <Row>
          {(props.teamList ?? []).map((team, key) => (
            <Col
              key={key}
              xs={6}
              sm={4}
              className="px-3 py-4 border-bottom theme-col"
              role="button"
              onClick={() => props.onClickTeam(team)}
            >
              <Center>
                <LogoRound
                  url={team?.logo_url!}
                  isProfile={true}
                  name={team.name!}
                  bgHexColor={AppTheme.primary}
                />
              </Center>
              <SpacingHeight value={type === 1 ? 15 : 18} />
              <TextBlock
                fontName="bold"
                center={true}
                fontSize="16_17"
                textColor="theme-label"
              >
                {textCase(team.name!)}
              </TextBlock>
              <SpacingHeight value={5} />
              <TextBlock
                fontName="book"
                center={true}
                fontSize="14_15"
                textColor="theme-sublabel"
              >
                {textCase(team.title!)}
              </TextBlock>
            </Col>
          ))}
        </Row>
      )}
    </>
  );
};

export default BranchTeamList;
